import type { Partner } from '../../model/domain/Partner';
import type { PartnerTO } from '../to/PartnerTO';

const toDomain = (to: PartnerTO): Partner =>
  ({
    id: to.id,
    logoId: to.l,
    url: to.u,
    name: to.n,
    showTermOfUse: to.showTermOfUse,
    termOfUseUrl: to.termOfUseUrl,
    showFeedbackAlways: to.showFeedbackAlways,
    showLeaderboard: to.showLeaderboard,
    enableLibrary: to.enableLibrary,
    enableUserPerformance: to.enableUserPerformance,
    enableExternalAnalytics: to.enableExternalAnalytics,
    allowUsersChangeRemindDays: to.allowUsersChangeRemindDays,
    allowUsersChangeRemindTime: to.allowUsersChangeRemindTime,
  }) as Partner;

const fromDomain = (d: Partner): PartnerTO =>
  ({
    id: d.id,
    l: d.logoId,
  }) as PartnerTO;

export default {
  toDomain,
  fromDomain,
};
